import { render } from "./AvatarRounded.vue?vue&type=template&id=31495f16"
import script from "./AvatarRounded.vue?vue&type=script&lang=js"
export * from "./AvatarRounded.vue?vue&type=script&lang=js"

import "./AvatarRounded.vue?vue&type=style&index=0&id=31495f16&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__